module.exports = __webpack_public_path__ + "static/media/thumb.6b01c616.jpg";